import type { PipPosition } from "./pip-snap";

export interface PipCoordinateOffset {
	x: number;
	y: number;
}

export function resolvePipCoordinateOffset(
	boundsStage: HTMLElement,
	portalStage: HTMLElement,
): PipCoordinateOffset {
	const boundsRect = boundsStage.getBoundingClientRect();
	const portalRect = portalStage.getBoundingClientRect();
	return {
		x: portalRect.left - boundsRect.left,
		y: portalRect.top - boundsRect.top,
	};
}

export function toPortalPosition(
	boundsPosition: PipPosition,
	offset: PipCoordinateOffset,
): PipPosition {
	return {
		x: boundsPosition.x - offset.x,
		y: boundsPosition.y - offset.y,
	};
}

export function toBoundsPosition(
	portalPosition: PipPosition,
	offset: PipCoordinateOffset,
): PipPosition {
	return {
		x: portalPosition.x + offset.x,
		y: portalPosition.y + offset.y,
	};
}

export function resolvePointerPositionInStage(
	event: { clientX: number; clientY: number },
	stage: HTMLElement,
): PipPosition {
	const rect = stage.getBoundingClientRect();
	return {
		x: event.clientX - rect.left,
		y: event.clientY - rect.top,
	};
}
